import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";

// What a draft call still needs before publishing; the backend has the final say
export default function ReadinessChecklist({ checks }) {
  return (
    <section className="flex flex-col gap-3">
      <h3 className="text-sm font-semibold text-slate-700">Ready to publish?</h3>
      <ul className="flex flex-col gap-2">
        {checks.map((c) => (
          <li key={c.label} className="flex items-center gap-2 text-sm">
            {c.ok ? <CheckCircleIcon className="h-5 w-5 shrink-0 text-green-600" /> : <XCircleIcon className="h-5 w-5 shrink-0 text-slate-300" />}
            <span className={c.ok ? "text-slate-800" : "text-slate-500"}>{c.label}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
